import { ViewModes } from '../../constants/view-modes';
export const getBasicParams = (state) => state.baseParams;
export const getViewMode = (state) => getBasicParams(state).viewMode;
export const getFormFactor = (state) => getBasicParams(state).formFactor;
export const getInstance = (state) => getBasicParams(state).instance;
export const getInstanceValues = (state) => getBasicParams(state).instanceValues;
export const getLanguage = (state) => getBasicParams(state).language || 'en';
export const getIsSSR = (state) => getBasicParams(state).isSSR;
export const isDebug = (state) => getBasicParams(state).isDebug;
export const isProduction = (state) => getBasicParams(state).isProduction;
export const getAppDefinitionId = (state) => getBasicParams(state).appDefinitionId;
export const getIsMaInstalled = (state) => getBasicParams(state).isMaInstalled;
export const getIsChatInstalled = (state) => getBasicParams(state).isChatInstalled;
export const getIsRtl = (state) => getBasicParams(state).isRTL;
export const isSite = (state) => getViewMode(state) === ViewModes.Site;
export const getIsEditor = (state) => getViewMode(state) === ViewModes.Editor;
export const getIsPreview = (state) => getViewMode(state) === ViewModes.Preview;
export const isDashboard = (state) => getViewMode(state) === ViewModes.Dashboard;
export const isSeo = (state) => getBasicParams(state).isSeo;
export const getIsMobile = (state) => getFormFactor(state) === 'Mobile';
export const getInstanceValue = (state, name) => { var _a; return (_a = getInstanceValues(state)) === null || _a === void 0 ? void 0 : _a[name]; };
export const getIsDemoMode = (state) => getInstanceValue(state, 'demoMode');
export const getBiToken = (state) => getInstanceValue(state, 'biToken');
export const getAid = (state) => getInstanceValue(state, 'aid');
export const getPermissions = (state) => getInstanceValue(state, 'permissions');
export const getMetaSiteId = (state) => getInstanceValue(state, 'metaSiteId');
export const getSiteIsTemplate = (state) => getInstanceValue(state, 'siteIsTemplate');
// export const isCacheableRendering = (state: State) => isSSR(state) && !getCurrentUser(state);
//
export const isLoggingEnabled = (state) => isDebug(state) || !isProduction(state);
//# sourceMappingURL=base-params-selectors.js.map